import { DEFAULT_DOCUMENT_PROFILE, serializeAnzahl } from "../common";
import {
  type BaseData,
  type ChildRef,
  type ElementData,
  type Keyword,
  type MessageHeader,
  type NormReference,
  type Relation,
  type SchemaMessage,
  NAMESPACE as XDF3_NS,
} from "./schema";

const XDF3_SCHEMA_MESSAGE = "xdatenfelder.stammdatenschema.0102";

const XDF3_MESSAGE_HEADER = "header";
const XDF3_MESSAGE_ID = "nachrichtID";
const XDF3_CREATION_TIME = "erstellungszeitpunkt";

const XDF3_SCHEMA = "stammdatenschema";
const XDF3_IDENTIFIKATION = "identifikation";
const XDF3_ID = "id";
const XDF3_VERSION = "version";
const XDF3_NAME = "name";
const XDF3_BESCHREIBUNG = "beschreibung";
const XDF3_DEFINITION = "definition";
const XDF3_BEZUG = "bezug";
const XDF3_STICHWORT = "stichwort";
const XDF3_FREIGABE_STATUS = "freigabestatus";
const XDF3_VERSIONSHINWEIS = "versionshinweis";
const XDF3_STATUS_GESETZT_AM = "statusGesetztAm";
const XDF3_STATUS_GESETZT_DURCH = "statusGesetztDurch";
const XDF3_GUELTIG_AB = "gueltigAb";
const XDF3_GUELTIG_BIS = "gueltigBis";
const XDF3_LETZTE_AENDERUNG = "letzteAenderung";
const XDF3_RELATION = "relation";
const XDF3_VEROEFFENTLICHUNGSDATUM = "veroeffentlichungsdatum";
const XDF3_BEZEICHNUNG = "bezeichnung";
const XDF3_HILFETEXT = "hilfetext";
const XDF3_DOKUMENTSTECKBRIEF = "dokumentsteckbrief";
const XDF3_ABLEITUNGSMODIFIKATIONEN_STRUKTUR =
  "ableitungsmodifikationenStruktur";
const XDF3_ABLEITUNGSMODIFIKATIONEN_REPRAESENTATION =
  "ableitungsmodifikationenRepraesentation";

// const XDF3_REGEL = "regel";
const XDF3_STRUKTUR = "struktur";
const XDF3_ANZAHL = "anzahl";
const XDF3_ENTHAELT = "enthaelt";
const XDF3_GRUPPE = "datenfeldgruppe";
const XDF3_DATENFELD = "datenfeld";
// const XDF3_ART = "art";
const XDF3_BEZEICHNUNG_EINGABE = "bezeichnungEingabe";
const XDF3_BEZEICHNUNG_AUSGABE = "bezeichnungAusgabe";
const XDF3_SCHEMA_ELEMENT_ART = "schemaelementart";
const XDF3_HILFETEXT_EINGABE = "hilfetextEingabe";
const XDF3_HILFETEXT_AUSGABE = "hilfetextAusgabe";
const XDF3_FELDART = "feldart";
const XDF3_DATENTYP = "datentyp";
// const XDF3_PRAEZISIERUNG = "praezisierung";
// const XDF3_INHALT = "inhalt";
const XDF3_VORBEFUELLUNG = "vorbefuellung";
// const XDF3_WERTE = "werte";
// const XDF3_WERT = "wert";
// const XDF3_CODE = "code";
// const XDF3_HILFE = "hilfe";
// const XDF3_CODELISTE_REFERENZ = "codelisteReferenz";
// const XDF3_CODE_KEY = "codeKey";
// const XDF3_NAME_KEY = "nameKey";
// const XDF3_HELP_KEY = "helpKey";
// const XDF3_MAX_SIZE = "maxSize";
// const XDF3_MEDIA_TYPE = "mediaType";

// const XDF3_FREITEXT_REGEL = "freitextRegel";
// const XDF3_FACHLICHER_ERSTELLER = "fachlicherErsteller";
// const XDF3_TYP = "typ";
// const XDF3_PARAM = "param";
// const XDF3_ZIEL = "ziel";
// const XDF3_SKRIPT = "skript";
// const XDF3_FEHLER = "fehler";

const XDF3_PRAEDIKAT = "praedikat";
// const XDF3_OBJEKT = "objekt";

// const XDF3_GENERICODE_IDENTIFIKATION = "genericodeIdentification";
// const XDF3_CANONICAL_IDENTIFICATION = "canonicalIdentification";
// const XDF3_CANONICAL_VERSION_URI = "canonicalVersionUri";

const FREIGABE_STATUS_CODE_LIST_URI = "urn:xoev-de:xprozess:codeliste:status";
const FREIGABE_STATUS_CODE_LIST_VERSION = "2022-07-12";

const RELATION_TYP_CODE_LIST_URI =
  "urn:xoev-de:fim-datenfelder:codeliste:relation";
const RELATION_TYP_CODE_LIST_VERSION = "1.2";

const ABLEITUNGS_REPR_CODE_LIST_URI =
  "urn:xoev-de:fim:codeliste:xdatenfelder.ableitungsmodifikationenRepraesentation";
const ABLEITUNGS_REPR_CODE_LIST_VERSION = "1.0";

const ABLEITUNGS_STRUKTUR_CODE_LIST_URI =
  "urn:xoev-de:fim:codeliste:xdatenfelder.ableitungsmodifikationenStruktur";
const ABLEITUNGS_STRUKTUR_CODE_LIST_VERSION = "1.0";

const SCHEMA_ELEMENT_ART_CODE_LIST_URI =
  "urn:xoev-de:fim:codeliste:xdatenfelder.schemaelementart";
const SCHEMA_ELEMENT_ART_CODE_LIST_VERSION = "1.0";

const FELDART_CODE_LIST_URI = "urn:xoev-de:fim:codeliste:xdatenfelder.feldart";
const FELDART_CODE_LIST_VERSION = "2.0";

const DATENTYP_CODE_LIST_URI =
  "urn:xoev-de:fim:codeliste:xdatenfelder.datentyp";
const DATENTYP_CODE_LIST_VERSION = "2.0";

const VORBEFUELLUNG_CODE_LIST_URI =
  "urn:xoev-de:fim:codeliste:xdatenfelder.vorbefuellung";
const VORBEFUELLUNG_CODE_LIST_VERSION = "1.0";

const SERIALIZER = new XMLSerializer();

export function serializeMessage(message: SchemaMessage): string {
  const doc = document.implementation.createDocument(
    XDF3_NS,
    XDF3_SCHEMA_MESSAGE,
  );

  doc.documentElement.appendChild(serializeHeader(doc, message.header));
  doc.documentElement.appendChild(serializeSchema(doc, message));

  return SERIALIZER.serializeToString(doc);
}

function serializeHeader(doc: XMLDocument, header: MessageHeader): Element {
  const root = doc.createElementNS(XDF3_NS, XDF3_MESSAGE_HEADER);

  const nachrichtId = doc.createElementNS(XDF3_NS, XDF3_MESSAGE_ID);
  nachrichtId.textContent = header.nachrichtId;
  root.appendChild(nachrichtId);

  const erstellungsZeitpunkt = doc.createElementNS(XDF3_NS, XDF3_CREATION_TIME);
  erstellungsZeitpunkt.textContent = header.erstellungsZeitpunkt.toISOString();
  root.appendChild(erstellungsZeitpunkt);

  return root;
}

function serializeSchema(doc: XMLDocument, message: SchemaMessage): Element {
  const schema = message.schema;

  const root = doc.createElementNS(XDF3_NS, XDF3_SCHEMA);
  addAllgemeineAngaben(doc, root, schema);

  addValue(doc, root, XDF3_BEZEICHNUNG, schema.label);
  addValueIfNotNone(doc, root, XDF3_HILFETEXT, schema.help);

  root.appendChild(
    serializeCode(
      doc,
      XDF3_ABLEITUNGSMODIFIKATIONEN_STRUKTUR,
      0,
      ABLEITUNGS_STRUKTUR_CODE_LIST_URI,
      ABLEITUNGS_STRUKTUR_CODE_LIST_VERSION,
    ),
  );
  root.appendChild(
    serializeCode(
      doc,
      XDF3_ABLEITUNGSMODIFIKATIONEN_REPRAESENTATION,
      0,
      ABLEITUNGS_REPR_CODE_LIST_URI,
      ABLEITUNGS_REPR_CODE_LIST_VERSION,
    ),
  );

  root.appendChild(
    serializeIdentifier(
      doc,
      DEFAULT_DOCUMENT_PROFILE,
      undefined,
      XDF3_DOKUMENTSTECKBRIEF,
    ),
  );

  // TODO: _attach_rules(element, schema.regeln, message = message)

  addStrukturList(doc, root, schema.children, message);

  return root;
}

function addElementAngaben(
  doc: XMLDocument,
  root: Element,
  data: ElementData,
): void {
  addValue(doc, root, XDF3_BEZEICHNUNG_EINGABE, data.inputLabel);
  addValueIfNotNone(doc, root, XDF3_BEZEICHNUNG_AUSGABE, data.outputLabel);

  root.appendChild(
    serializeCode(
      doc,
      XDF3_SCHEMA_ELEMENT_ART,
      data.elementType,
      SCHEMA_ELEMENT_ART_CODE_LIST_URI,
      SCHEMA_ELEMENT_ART_CODE_LIST_VERSION,
    ),
  );

  addValueIfNotNone(doc, root, XDF3_HILFETEXT_EINGABE, data.inputHelp);
  addValueIfNotNone(doc, root, XDF3_HILFETEXT_AUSGABE, data.outputHelp);
}

function addAllgemeineAngaben(
  doc: XMLDocument,
  root: Element,
  data: BaseData,
): void {
  root.appendChild(serializeIdentifier(doc, data.id, data.version));

  addValue(doc, root, XDF3_NAME, data.name);
  addValueIfNotNone(doc, root, XDF3_BESCHREIBUNG, data.description);
  addValueIfNotNone(doc, root, XDF3_DEFINITION, data.definition);
  addBezug(doc, root, data.normReferences);

  root.appendChild(
    serializeCode(
      doc,
      XDF3_FREIGABE_STATUS,
      data.releaseState,
      FREIGABE_STATUS_CODE_LIST_URI,
      FREIGABE_STATUS_CODE_LIST_VERSION,
    ),
  );

  if (data.stateSetAt !== undefined) {
    addValue(doc, root, XDF3_STATUS_GESETZT_AM, data.stateSetAt.toISOString());
  }

  addValueIfNotNone(doc, root, XDF3_STATUS_GESETZT_DURCH, data.stateSetBy);

  if (data.validSince !== undefined) {
    addValue(doc, root, XDF3_GUELTIG_AB, toDateString(data.validSince));
  }

  if (data.validUntil !== undefined) {
    addValue(doc, root, XDF3_GUELTIG_BIS, toDateString(data.validUntil));
  }

  addValueIfNotNone(doc, root, XDF3_VERSIONSHINWEIS, data.versionHint);

  if (data.publishedAt !== undefined) {
    addValue(
      doc,
      root,
      XDF3_VEROEFFENTLICHUNGSDATUM,
      toDateString(data.publishedAt),
    );
  }

  if (data.lastChangedAt !== undefined) {
    addValue(
      doc,
      root,
      XDF3_LETZTE_AENDERUNG,
      data.lastChangedAt.toISOString(),
    );
  }

  addRelationList(doc, root, data.relations);
  addStichwortList(doc, root, data.keywords);
}

function serializeIdentifier(
  doc: XMLDocument,
  id: string,
  version: string | undefined,
  root_tag: string = XDF3_IDENTIFIKATION,
): Element {
  const root = doc.createElementNS(XDF3_NS, root_tag);

  const idElement = doc.createElementNS(XDF3_NS, XDF3_ID);
  idElement.textContent = id;
  root.appendChild(idElement);

  if (version !== undefined) {
    const versionElement = doc.createElementNS(XDF3_NS, XDF3_VERSION);
    versionElement.textContent = version;
    root.appendChild(versionElement);
  }

  return root;
}

function addBezug(doc: XMLDocument, root: Element, bezugList: NormReference[]) {
  for (const bezug of bezugList) {
    const element = doc.createElementNS(XDF3_NS, XDF3_BEZUG);
    element.textContent = bezug.value;
    if (bezug.link !== undefined) {
      element.setAttribute("link", bezug.link);
    }

    root.appendChild(element);
  }
}

function addRelationList(
  doc: XMLDocument,
  root: Element,
  relationList: Relation[],
) {
  for (const relation of relationList) {
    const element = doc.createAttributeNS(XDF3_NS, XDF3_RELATION);

    element.appendChild(
      serializeCode(
        doc,
        XDF3_PRAEDIKAT,
        relation.praedikat,
        RELATION_TYP_CODE_LIST_URI,
        RELATION_TYP_CODE_LIST_VERSION,
      ),
    );
    element.appendChild(
      serializeIdentifier(doc, relation.objekt.id, relation.objekt.version),
    );

    root.appendChild(element);
  }
}

function addStichwortList(
  doc: XMLDocument,
  root: Element,
  stichwortList: Keyword[],
) {
  for (const stichwort of stichwortList) {
    const element = doc.createElementNS(XDF3_NS, XDF3_STICHWORT);
    element.textContent = stichwort.value;

    if (stichwort.uri !== undefined) {
      element.setAttribute("uri", stichwort.uri);
    }

    root.appendChild(element);
  }
}

function serializeGroup(
  doc: XMLDocument,
  id: string,
  message: SchemaMessage,
): Element {
  const group = message.gruppen[id];

  const root = doc.createElementNS(XDF3_NS, XDF3_GRUPPE);

  addAllgemeineAngaben(doc, root, group);
  addElementAngaben(doc, root, group);

  // if group.art is not None:
  // element.append(
  //     _serialize_code(
  //         XDF3_ART,
  //         group.art.value,
  //         list_uri = GRUPPENART_CODE_LIST_URI,
  //         list_version = GRUPPENART_CODE_LIST_VERSION,
  //     )
  // )

  // _attach_rules(element, group.regeln, message)

  addStrukturList(doc, root, group.children, message);

  return root;
}

function serializeField(
  doc: XMLDocument,
  id: string,
  message: SchemaMessage,
): Element {
  const field = message.felder[id];

  const root = doc.createElementNS(XDF3_NS, XDF3_DATENFELD);

  addAllgemeineAngaben(doc, root, field);
  addElementAngaben(doc, root, field);

  root.appendChild(
    serializeCode(
      doc,
      XDF3_FELDART,
      field.inputType,
      FELDART_CODE_LIST_URI,
      FELDART_CODE_LIST_VERSION,
    ),
  );

  root.appendChild(
    serializeCode(
      doc,
      XDF3_DATENTYP,
      field.dataType,
      DATENTYP_CODE_LIST_URI,
      DATENTYP_CODE_LIST_VERSION,
    ),
  );

  //if field.praezisierung is not None:
  //praezisierung = ET.SubElement(element, XDF3_PRAEZISIERUNG)
  //if field.praezisierung.min_length is not None:
  //praezisierung.attrib["minLength"] = str(field.praezisierung.min_length)
  //if field.praezisierung.max_length is not None:
  //praezisierung.attrib["maxLength"] = str(field.praezisierung.max_length)
  //if field.praezisierung.min_value is not None:
  //praezisierung.attrib["minValue"] = str(field.praezisierung.min_value)
  //if field.praezisierung.max_value is not None:
  //praezisierung.attrib["maxValue"] = str(field.praezisierung.max_value)
  //if field.praezisierung.pattern is not None:
  //praezisierung.attrib["pattern"] = str(field.praezisierung.pattern)

  //_add_value_if_not_none(element, XDF3_INHALT, field.inhalt)

  root.appendChild(
    serializeCode(
      doc,
      XDF3_VORBEFUELLUNG,
      field.fillType,
      VORBEFUELLUNG_CODE_LIST_URI,
      VORBEFUELLUNG_CODE_LIST_VERSION,
    ),
  );

  //if field.werte is not None:
  //element.append(_serialize_embedded_code_list(field.werte))

  //if field.codeliste_referenz is not None:
  //element.append(_serialize_code_list_reference(field.codeliste_referenz))

  //_add_value_if_not_none(element, XDF3_CODE_KEY, field.code_key)
  //_add_value_if_not_none(element, XDF3_NAME_KEY, field.name_key)
  //_add_value_if_not_none(element, XDF3_HELP_KEY, field.help_key)
  //_attach_rules(element, field.regeln, message)
  //_add_value_if_not_none(element, XDF3_MAX_SIZE, field.max_size)

  //for media_type in field.media_type:
  //    ET.SubElement(element, XDF3_MEDIA_TYPE).text = media_type

  return root;
}

function addStrukturList(
  doc: XMLDocument,
  root: Element,
  strukturList: ChildRef[],
  message: SchemaMessage,
) {
  for (const reference of strukturList) {
    const element = doc.createElementNS(XDF3_NS, XDF3_STRUKTUR);
    root.appendChild(element);

    const anzahlElement = doc.createElementNS(XDF3_NS, XDF3_ANZAHL);
    element.appendChild(anzahlElement);
    anzahlElement.textContent = serializeAnzahl(reference.anzahl);

    addBezug(doc, element, reference.normReferences);

    const enthaehltElement = doc.createElementNS(XDF3_NS, XDF3_ENTHAELT);
    element.appendChild(enthaehltElement);
    if (reference.type === "dataGroup") {
      enthaehltElement.appendChild(
        serializeGroup(doc, reference.element.id, message),
      );
    } else {
      enthaehltElement.appendChild(
        serializeField(doc, reference.element.id, message),
      );
    }
  }
}

function serializeCode(
  doc: XMLDocument,
  tag: string,
  value: string | number,
  listUri: string,
  listVersion: string | undefined = undefined,
): Element {
  const element = doc.createElementNS(XDF3_NS, tag);
  element.setAttribute("listURI", listUri);
  if (listVersion !== undefined) {
    element.setAttribute("listVersionID", listVersion);
  }

  const codeElement = doc.createElement("code");
  codeElement.textContent = value.toString();
  element.appendChild(codeElement);

  return element;
}

function addValueIfNotNone(
  doc: XMLDocument,
  root: Element,
  tag: string,
  value: string | number | undefined,
) {
  if (value === undefined) {
    return;
  }

  addValue(doc, root, tag, value);
}

function addValue(
  doc: XMLDocument,
  root: Element,
  tag: string,
  value: string | number,
) {
  const element = doc.createElementNS(XDF3_NS, tag);
  element.textContent = value.toString();
  root.appendChild(element);
}

function toDateString(date: Date): string {
  const year = date.getUTCFullYear().toString();
  const month = date.getUTCMonth().toString().padStart(2, "0");
  const day = date.getUTCDay().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
}
